import HeartOutlined from '../../src/legacy/HeartOutlined';
export default HeartOutlined;
